const PAYOUT_TYPES = {
    WITHDRAWAL: 'withdrawal',
    PAYMENTOUT: 'paymentOut',
};

const FIELD_TYPES = {
    TEXT: 'text',
    TEXTAREA: 'textarea',
    SELECT: 'select',
};

export const REQUIRED_FIELDS = ['beneficiaryName', 'beneficiaryCountry', 'bankCountry'];

const getFields = (type = PAYOUT_TYPES.WITHDRAWAL, fields = 'some') => {
    const {
        beneficiaryName,
        iban,
        bankAddress,
        bankName,
        beneficiaryAddress,
        reference,
        sortCode,
        swiftCode,
        accountNumber,
        additionalInfo,
        bankCountry,
        beneficiaryCountry,
        nickname,
    } = fieldList;

    return fields == 'some'
        ? {
            list: [beneficiaryName],
            state: { beneficiaryName: '' },
            fieldItems: ['beneficiaryName'],
        }
        : {
            list: [
                beneficiaryName,
                beneficiaryCountry,
                beneficiaryAddress,
                bankName,
                bankCountry,
                bankAddress,
                nickname,
                accountNumber,
                sortCode,
                iban,
                swiftCode,
                additionalInfo,
                reference,
            ],
            state: {
                beneficiaryName: '',
                beneficiaryCountry: '',
                beneficiaryAddress: '',
                bankName: '',
                bankAddress: '',
                accountNumber: '',
                sortCode: '',
                iban: '',
                swiftCode: '',
                reference: '',
                additionalInfo: '',
                bankCountry: "",
                save: false,
                nickname: '',
            },
        };
};

const fieldList = {
    beneficiaryName: {
        name: 'beneficiaryName',
        dataKey: 'beneficiaryName',
        label: 'Beneficiary Name',
        placeholder: 'enter beneficiary name',
        type: FIELD_TYPES.TEXT,
        hasError: value => {
            if (typeof value !== 'string' || value.trim() === '') {
                return 'Beneficiary name cannot be empty';
            }
        },
    },
    beneficiaryAddress: {
        name: 'beneficiaryAddress',
        dataKey: 'beneficiaryAddress',
        label: 'Beneficiary Address',
        placeholder: 'enter beneficiary address',
        type: FIELD_TYPES.TEXT,
    },
    bankName: {
        name: 'bankName',
        dataKey: 'bankName',
        label: 'Bank Name',
        placeholder: 'enter bank name',
        type: FIELD_TYPES.TEXT,
    },
    bankAddress: {
        name: 'bankAddress',
        dataKey: 'bankAddress',
        label: 'Bank Address',
        placeholder: 'enter bank address',
        type: FIELD_TYPES.TEXT,
        includeSave: {
            dataKey: 'save',
            label: 'save this bank account',
        },
    },
    accountNumber: {
        name: 'accountNumber',
        dataKey: 'beneficiaryAccountNumber',
        label: 'Account Number',
        placeholder: 'enter account number',
        type: FIELD_TYPES.TEXT,
    },
    sortCode: {
        name: 'sortCode',
        dataKey: 'sortCode',
        label: 'Sort Code',
        placeholder: 'enter sort code',
        type: FIELD_TYPES.TEXT,
    },
    swiftCode: {
        name: 'swiftCode',
        dataKey: 'swift',
        label: 'Swift Code',
        placeholder: 'enter swift code',
        type: FIELD_TYPES.TEXT,
    },
    reference: {
        name: 'reference',
        dataKey: 'reference',
        label: 'Reference',
        placeholder: 'enter your reference',
        type: FIELD_TYPES.TEXT,
        showOnAccountSelect: true,
    },
    additionalInfo: {
        name: 'additionalInfo',
        dataKey: 'additionalBankDetails',
        label: 'Additional Info',
        placeholder: 'EG: routing number',
        type: FIELD_TYPES.TEXTAREA,
        style: 'h-40',
        showOnAccountSelect: true,
    },
    iban: {
        name: 'iban',
        dataKey: 'iban',
        label: 'Iban',
        placeholder: 'enter iban',
        type: FIELD_TYPES.TEXT,
    },
    beneficiaryCountry: {
        name: 'beneficiaryCountry',
        dataKey: 'beneficiaryCountry',
        label: 'Beneficiary Country',
        type: FIELD_TYPES.SELECT,
        dataSet: 'countries',
        placeholder: 'enter beneficiary country',
        hasError: value => {
            if (typeof value !== 'string' || value.trim() === '') {
                return 'Beneficiary country is a required field';
            }
        },
    },
    bankCountry: {
        name: 'bankCountry',
        dataKey: 'bankCountry',
        label: 'Bank Country',
        type: FIELD_TYPES.SELECT,
        dataSet: 'countries',
        placeholder: 'enter bank country',
        hasError: value => {
            if (typeof value !== 'string' || value.trim() === '') {
                return 'Bank country is a required field';
            }
        },
    },
    nickname: {
        name: 'accountNickName',
        dataKey: 'accountNickName',
        label: 'Account Nickname',
        placeholder: 'Enter account nickname',
        hasError: value => {
            if (typeof value !== 'string' || value.trim() === '') {
                return 'Account nickname is a required field';
            }
        },
        // showOnAccountSelect: true,
    },
};

const getMetadata = type => {
    return type == 'withdrawal' || type == 'withdraw'
        ? {
            heading: 'withdrawal',
            amountWithCurrencyLabel: 'withdraw',
            transactionType: 'Withdrawal',
            messageWord: 'withdrawn',
        }
        : {
            heading: 'Third-party Payment',
            amountWithCurrencyLabel: 'currency',
            transactionType: 'Payment Out',
            messageWord: 'sent',
        };
};

export { getFields, getMetadata };
